var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 698.7 170",
    style: {
      enableBackground: "new 0 0 698.7 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#646464}")), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.4 86.3c0-21.4-6.1-32.4-18.3-33-4.9-.2-9.6.5-14.2 2.3-3.7 1.3-6.2 2.6-7.5 3.9v51.1c7.8 4.9 14.8 7.2 20.8 6.8 12.8-.7 19.2-11.1 19.2-31.1zm15.1.9c0 10.9-2.6 19.9-7.7 27.1-5.7 8.1-13.7 12.3-23.8 12.5-7.6.3-15.5-2.2-23.6-7.2v46.5l-13.1-4.7V58.3c2.2-2.6 4.9-4.9 8.3-6.8 7.8-4.5 17.3-6.9 28.4-7l.2.2c10.2-.1 18.1 4.1 23.6 12.5 5.1 7.8 7.7 17.8 7.7 30zm80.1 30.5c0 14.6-1.5 24.7-4.4 30.3-2.9 5.6-8.5 10.1-16.8 13.5-6.7 2.6-13.9 4.1-21.7 4.3l-2.2-8.3c7.9-1.1 13.5-2.2 16.7-3.2 6.4-2.2 10.7-5.5 13.1-9.9 1.9-3.6 2.9-10.5 2.9-20.6v-3.4c-8.8 4-18.5 6.1-28.2 6.1-6.2.1-12.3-2.1-17.1-6.1-5.5-4.4-8.3-10.1-8.3-16.9V49l13.1-4.5v54.9c0 5.9 1.9 10.4 5.7 13.6 3.8 3.2 8.7 4.7 14.7 4.6 6-.1 12.5-2.5 19.3-7v-64h13.1l.1 71.1zm51.2 8.5-4.3.2c-7.4 0-13.2-1.8-17.3-5.3-4.1-3.5-6.2-8.5-6.2-14.7V54.8h-9v-8.2h9v-22l13.1-4.7v26.6h14.7v8.2h-14.7V106c0 4.9 1.3 8.4 4 10.4 2.3 1.7 5.9 2.6 10.8 2.9v6.9h-.1zm79.4-1.1h-13.1V74.5c0-5.2-1.2-9.6-3.6-13.3-2.8-4.2-6.6-6.3-11.5-6.3-6 0-13.5 3.2-22.5 9.5V125h-13.1V4.1l13-4.1v55.1c8.4-6.1 17.5-9.2 27.5-9.2 6.9 0 12.6 2.3 16.9 7 4.3 4.7 6.5 10.5 6.5 17.4l-.1 54.8zm69.7-40.8c0-8.2-1.6-15-4.7-20.4-3.7-6.6-9.5-10-17.2-10.4-14.4.8-21.5 11.1-21.5 30.8 0 9.1 1.5 16.6 4.5 22.7 3.8 7.7 9.6 11.5 17.3 11.4 14.3-.1 21.6-11.5 21.6-34.1zm14.3.1c0 11.7-3 21.5-9 29.3-6.6 8.7-15.7 13.1-27.3 13.1-11.5 0-20.5-4.4-26.9-13.1-5.9-7.8-8.8-17.5-8.8-29.3 0-11 3.2-20.3 9.5-27.8 6.7-8 15.5-12 26.4-12s19.8 4 26.6 12c6.3 7.5 9.5 16.7 9.5 27.8zm75.2 40.7h-13.1V71.6c0-5.9-1.8-10.4-5.3-13.7-3.5-3.3-8.2-4.9-14.1-4.7-6.2.1-12.1 2.2-17.7 6.1v65.9H585V57.6c7.5-5.5 14.5-9.1 20.8-10.8 6-1.6 11.3-2.3 15.8-2.3 3.1 0 6 .3 8.8.9 5.2 1.2 9.3 3.4 12.6 6.6 3.6 3.6 5.4 7.9 5.4 12.9v60.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.0606,
    y1: 161.7169,
    x2: 86.181,
    y2: 83.3256,
    gradientTransform: "matrix(1 0 0 -1 0 171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5a9fd4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#306998"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.8 4.6c-6.7 0-13.2.6-18.9 1.6-16.7 2.9-19.7 9.1-19.7 20.5v15h39.5v5H27.4c-11.5 0-21.5 6.9-24.6 20-3.6 15-3.8 24.4 0 40.1 2.8 11.7 9.5 20 21 20h13.6v-18c0-13 11.3-24.5 24.6-24.5h39.4c11 0 19.7-9 19.7-20V26.7c0-10.7-9-18.7-19.7-20.5-6.8-1.1-13.7-1.6-20.6-1.6zM59.5 16.7c4.1 0 7.4 3.4 7.4 7.5s-3.3 7.5-7.4 7.5c-4.1 0-7.4-3.4-7.4-7.5s3.3-7.5 7.4-7.5z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.2259,
    y1: 35.6712,
    x2: 88.9992,
    y2: 81.705,
    gradientTransform: "matrix(1 0 0 -1 0 171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd43b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffe873"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126 46.8v17.5c0 13.6-11.5 25-24.6 25H62c-10.8 0-19.7 9.2-19.7 20v37.6c0 10.7 9.3 17 19.7 20 12.5 3.7 24.5 4.3 39.4 0 9.9-2.9 19.7-8.7 19.7-20v-15H81.7v-5h59.1c11.5 0 15.7-8 19.7-20 4.1-12.4 3.9-24.2 0-40.1-2.8-11.4-8.2-20-19.7-20H126zm-22.1 95.1c4.1 0 7.4 3.4 7.4 7.5 0 4.2-3.3 7.5-7.4 7.5-4.1 0-7.4-3.4-7.4-7.5-.1-4.1 3.3-7.5 7.4-7.5z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.9 34.8h2.3V20.4h5.4v-1.7h-13.2v1.7h5.4l.1 14.4m9.8 0h2V21.6l4.3 13.2h2.2l4.4-13.1v13.1h2.1V18.7h-2.8L691 32.5l-4.1-13.8h-3.2v16.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPy);
export default __webpack_public_path__ + "static/media/py.1a60d6192557f05fc2e90e543ad75c10.svg";
export { ForwardRef as ReactComponent };